import { withTheme, SvySwitch as Switch } from '@innovorder/savory';
import { withIntlLabel } from '@/locales/withIntlLabel';
import styled from '@emotion/styled';

const SvySwitchTmp = withIntlLabel(withTheme(Switch));

export const SvySwitch = styled(SvySwitchTmp, {
    shouldForwardProp: (prop) => !['isTouched', 'isDirty'].includes(prop),
})``;
